import * as React from "react";
import moment from "moment";
import {
    getFormattedAddress,
    isNullOrWhitespace,
} from "../../services/stringService";

export const RetrocheckFacesheetPersonal = ({patientData}) => {
    return (
        <div className="facesheet-personal">
            {patientData && 
                <div className="facesheet-personal__info">
                    <div className="facesheet-personal__left">
                        <div className="facesheet-personal__info-item">
                            <span className="p-regular">
                                <span className="h5">Gender </span>
                                <span className="p-regular">{patientData.sex}</span>
                            </span>
                        </div>
                    
                        <div className="facesheet-personal__info-item">
                            <span className="h5">SSN </span>
                            <span className="p-regular">
                                {isNullOrWhitespace(patientData.ssn) ? "" : `xxx-xx-${patientData.ssn.slice(-4)}`}
                            </span>
                        </div>
                        <div className="facesheet-personal__info-item">
                            <span className="p-regular">
                                <span className="h5">Address </span>
                                {getFormattedAddress(patientData.address)}
                            </span>
                        </div>
                    </div>
                    <div className="facesheet-personal__right">
                        <div className="facesheet-personal__info-item">
                            <span className="h5">DOB </span>
                            <span className="p-regular">{moment(patientData.dob).format("MM.DD.YYYY")}</span>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};
